import { TextArea } from "@/Components/Inputs";
import React from "react";


interface UserEditDialogBoxViewProps {
    userForDialog : Record<string, any>;
    setUserForDialog: (user: Record<string, any>) => void;
}

export const UserEditDialogBoxView = ({
    userForDialog,
    setUserForDialog
}: UserEditDialogBoxViewProps) => {

    const handleNotesChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setUserForDialog({...userForDialog, notes: event.target.value});
    };

    return <>
    
    <TextArea
            label="Notes"
            name="notes"
            onChange={handleNotesChange}
            value={userForDialog.notes || ""}
        />
    
    </>;
};
        